import { BaseColors } from "./tokens";
import { IStoreTheme } from "../classes/interfaces";
import { shade, clampToLight } from "./colorUtils";

const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

/**
 * Traduz os 4 papéis de cor da loja no subconjunto de BaseColors que
 * makeTheme(overrides?) aceita, derivando os tons intermediários que os
 * gradientes precisam. Sem tema, ou tema com qualquer campo fora do formato
 * #RRGGBB, => {} (tema padrão MenuChef) — os 4 valores vêm direto da rede
 * (leitura pública por suffix) e são interpolados como CSS bruto em dezenas
 * de styled-components; o backend valida o formato na escrita (contrato §5),
 * mas o frontend não deve depender só disso para nunca injetar CSS a partir
 * de uma string malformada.
 */
export function themeToOverrides(
  theme: IStoreTheme | null | undefined
): Partial<BaseColors> {
  if (!theme) return {};
  if (
    !HEX_COLOR.test(theme.primary) ||
    !HEX_COLOR.test(theme.secondary) ||
    !HEX_COLOR.test(theme.accent) ||
    !HEX_COLOR.test(theme.background)
  ) {
    return {};
  }
  const bg = clampToLight(theme.background);
  return {
    teal: theme.primary,
    tealLight: shade(theme.primary, 0.08),
    tealDeep: shade(theme.primary, -0.22),
    green: theme.secondary,
    greenLight: shade(theme.secondary, 0.1),
    accentOrange: theme.accent,
    bg,
    softBg: shade(bg, -0.02),
    // Fundo pálido dos badges de ícone (CardSection, ChoiceRow, GroupTabs...).
    // clampToLight (não shade) preserva a matiz da primária mesmo em cores
    // muito saturadas/escuras, onde um shade aditivo estouraria os canais.
    softTeal: clampToLight(theme.primary, 0.94),
  };
}
